var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlogPostBckgrndMob = function SvgBlogPostBckgrndMob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 330,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 119.425c90.903-83.4 266.604-148.224 565.638-36.477",
    stroke: "#F0F1F2",
    strokeOpacity: 0.05,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 248.926c27.287-17.165 90.179-37.253 150.771-20.328 72.773 20.328 126.937 28.284 221.752-52.174 67.872-57.596 199.156-129.59 377.703 44.043C871.464 338.369 944 328.205 944 328.205",
    stroke: "#F0F1F2",
    strokeOpacity: 0.05,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 29.084c113.259-62.968 181.838-9.367 266.523 91.07C391.25 268.081 518.499 229.438 653.578 53.023",
    stroke: "#F0F1F2",
    strokeOpacity: 0.05,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgBlogPostBckgrndMob as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzc1IiBoZWlnaHQ9IjMzMCIgdmlld0JveD0iMCAwIDM3NSAzMzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuNSIgZD0iTTAgMTE5LjQyNUM5MC45MDMgMzYuMDI0MiAyNjYuNjA0IC0yOC43OTg2IDU2NS42MzggODIuOTQ3NyIgc3Ryb2tlPSIjRjBGMUYyIiBzdHJva2Utb3BhY2l0eT0iMC4wNSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTAgMjQ4LjkyNkMyNy4yODcyIDIzMS43NjEgOTAuMTc4NiAyMTEuNjczIDE1MC43NzEgMjI4LjU5OEMyMjMuNTQ0IDI0OC45MjYgMjc3LjcwOCAyNTYuODgyIDM3Mi41MjMgMTc2LjQyNEM0NDAuMzk1IDExOC44MjggNTcxLjY3OSA0Ni44MzQyIDc1MC4yMjYgMjIwLjQ2N0M4NzEuNDY0IDMzOC4zNjkgOTQ0IDMyOC4yMDUgOTQ0IDMyOC4yMDUiIHN0cm9rZT0iI0YwRjFGMiIgc3Ryb2tlLW9wYWNpdHk9IjAuMDUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtZGFzaGFycmF5PSI0IDgiLz4KPHBhdGggZD0iTTAgMjkuMDg0M0MxMTMuMjU5IC0zMy44ODM5IDE4MS44MzggMTkuNzE3MSAyNjYuNTIzIDEyMC4xNTRDMzkxLjI1IDI2OC4wODEgNTE4LjQ5OSAyMjkuNDM4IDY1My41NzggNTMuMDIyNiIgc3Ryb2tlPSIjRjBGMUYyIiBzdHJva2Utb3BhY2l0eT0iMC4wNSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";